import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { DOC2SIGN_DOCUMENT_TYPE } from '../constants';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { isThisSecond } from "date-fns";
import { param } from "jquery";
import { LangContext } from "../LangContext.jsx";
class DossierDocuments extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            documents: [],
            search:'',
            secondColumnStart: 0,
            selectedDocuments: [],
            defaultDocsLoaded : false,
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentWillReceiveProps(props) {
        if (props.selected_documents != null && this.state.defaultDocsLoaded==false) { // only triger this once (the first time)
            this.setState({
                defaultDocsLoaded : true,
                selectedDocuments: props.selected_documents
            })
        }
    }

    componentDidMount() {
        this.getDocuments()
    }

    handleChange(e){
        this.setState({search: e.target.value, page: 1}, function () {
            this.getDocuments();
        });
    }

    async getDocuments() {
        var url = '/api/documents';
        const query = new URLSearchParams();
        query.append('orderBy', 'title')
        query.append('orderByDir', 'asc')
        if(this.state.search!=''){
            query.append('search', this.state.search)
        }
        const qs = query.toString();
        const response = await axios.get(url+`?${qs}`);
        this.setState({
            documents: response.data.data,
            secondColumnStart: Math.ceil(response.data.data.length / 2)
        })
    }

    handleCheck(event, id) {
        var updatedList = [...this.state.selectedDocuments];
        var item = this.state.documents.filter(obj => obj.id === id)[0];

        if (event.target.checked) {
            updatedList.push({
                id: item.id,
                title: item.title,
            });
        } else {
            updatedList = updatedList.filter(obj => obj.id !== item.id);
        }

        this.setState({selectedDocuments : updatedList})
    }

    isChecked(id) {
        return this.state.selectedDocuments.filter(obj => obj.id === id)[0] !== undefined;
    }

    render() {
        const { lang } = this.context; 
        return (
            <div>
                <div className="card card-custom gutter-b">
                    <div className="card-body">
                        <div className="row justify-content-end">
                            <div className="col-4">
                                <div className="input-icon">
                                    <input
                                        onChange={this.handleChange}
                                        name="search"
                                        type="text"
                                        className="form-control"
                                        placeholder={lang.get('messages.buscar_documentos')} />
                                    <span>
                                        <i className="flaticon2-search-1 text-primary icon-md"></i>
                                    </span> 
                                </div>
                            </div>
                        </div>

                        <p className="font-weight-bold mb-4">{lang.get('messages.listado_de_plantillas_de_documentos_disponibles')}</p>
                        <div className="row justify-content-center text-left">
                            <div  className="col-sm-6">
                                {this.state.documents.slice(0, this.state.secondColumnStart).map(({id, title, type_id}, i) => {
                                    return <>
                                        <div key={i} className="mb-2">
                                            <label className={`checkbox checkbox-outline ${type_id == DOC2SIGN_DOCUMENT_TYPE ? 'checkbox-disabled' : ''}`}>
                                                <input
                                                    value={i}
                                                    onChange={(e) => this.handleCheck(e, id)}
                                                    type="checkbox"
                                                    className="group-checkable"
                                                    checked={this.isChecked(id)}
                                                    disabled={type_id == DOC2SIGN_DOCUMENT_TYPE}
                                                />
                                                <span className="w-25px h-25px rounded-0 mr-3"></span>
                                                {title}
                                            </label>
                                        </div>
                                    </>;
                                })}
                            </div>
                            <div  className="col-sm-6">
                                {this.state.documents.slice(this.state.secondColumnStart).map(({id, title, type_id}, i) => {
                                    return <>
                                        <div key={i} className="mb-2">
                                            <label className={`checkbox checkbox-outline ${type_id == DOC2SIGN_DOCUMENT_TYPE ? 'checkbox-disabled' : ''}`}>
                                                <input
                                                    value={i}
                                                    onChange={(e) => this.handleCheck(e, id)}
                                                    type="checkbox"
                                                    className="group-checkable"
                                                    checked={this.isChecked(id)}
                                                    disabled={type_id == DOC2SIGN_DOCUMENT_TYPE}
                                                />
                                                <span className="w-25px h-25px rounded-0 mr-3"></span>
                                                {title}
                                            </label>
                                        </div>
                                    </>;
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DossierDocuments;

if (document.getElementById('DossierDocuments')) {
    ReactDOM.render(<DossierDocuments />, document.getElementById('DossierDocuments'));
}
